<ion-header>
    <ion-toolbar>
        <ion-title>{{'Select team' | translate}}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="close()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    @if(!isLoading){
        @if(teams?.length){
            <ion-list>
                <app-team-item *ngFor="let team of teams; let i = index;" [team]="team" (click)="selectTeam(i)"></app-team-item>
            </ion-list>
        } @else {
            <app-empty-page
                text="{{'Click on the plus button below to add a team' | translate}}"
                iconName="people"
            ></app-empty-page>
        }
    }@else {
      <div class="ion-padding content-width" *ngFor="let item of [0, 1, 2]">
        <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
      </div>
    }
</ion-content>
<app-create-team-fab
    [leagueId]="leagueId"
    [closeAllModalsOnSuccess]="false"
    (team)="teams.unshift($event)"
></app-create-team-fab>